module.exports = __webpack_public_path__ + "img/logo.074fb87.svg";